/* eslint-disable no-unreachable */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useDisconnect, useAccount } from "wagmi";
import { useConnectModal } from "@rainbow-me/rainbowkit";
import { isTablet, isMobile } from "react-device-detect";
import { Drawer, Dropdown, message } from "antd";
import Web3 from "web3";

import { formatFromWei } from "../../utils/ConvertWei";
import { Link, useNavigate, useLocation } from "react-router-dom";
import "../style.scss";
import { useNetworkState } from "../../utils/useNetwork";
import NetworkModal from "../network-modal";

const fillNetwork = (network: any) => {
  switch (network) {
    case 56:
      return "/images/bnb.png";
    case 1:
      return "/images/eth-item.png";
    case 43114:
      return "/images/avax.png";
    case 8453:
      return "/images/base.png";
    case 137:
      return "/images/poly.png";
    case 42161:
      return "/images/arb.png";
    case 185:
      return "/images/mint.png";
    case 995:
      return "/images/5ire.png";
    case 8668:
      return "/images/hela.png";
    case 146:
      return "/images/sonic.png";
    case 97:
      return "/images/bnb.png";
  }
};

const fillNetive = (network: any) => {
  switch (network) {
    case 56:
      return "BNB";
    case 1:
      return "ETH";
    case 43114:
      return "AVAX";
    case 8453:
      return "ETH";
    case 137:
      return "POL";
    case 42161:
      return "ETH";
    case 185:
      return "ETH";
    case 995:
      return "5IRE";
    case 8668:
      return "HLUSD";
    case 146:
      return "S";
    case 97:
      return "BNB";
  }
};

const fillRPC = (network: any) => {
  switch (network) {
    case 56:
      return "https://bnb-mainnet.g.alchemy.com/v2/8MQkqWDARK4G0Z-hIxkdhV6gA9vqfXs0";
    case 1:
      return "https://eth-mainnet.g.alchemy.com/v2/Ndjy9ivH6B-gwhfwwrYPBj3a68Cat0RO";
    case 43114:
      return "https://avax-mainnet.g.alchemy.com/v2/Ndjy9ivH6B-gwhfwwrYPBj3a68Cat0RO";
    case 8453:
      return "https://base-mainnet.g.alchemy.com/v2/Ndjy9ivH6B-gwhfwwrYPBj3a68Cat0RO";
    case 137:
      return "https://polygon-mainnet.g.alchemy.com/v2/Ndjy9ivH6B-gwhfwwrYPBj3a68Cat0RO";
    case 42161:
      return "https://arb-mainnet.g.alchemy.com/v2/Ndjy9ivH6B-gwhfwwrYPBj3a68Cat0RO";
    case 185:
      return "https://global.rpc.mintchain.io";
    case 995:
      return "https://rpc.5ire.network";
    case 8668:
      return "https://mainnet-rpc.helachain.com";
    case 146:
      return "https://rpc.soniclabs.com";
    case 97:
      return "https://bsc-testnet-dataseed.bnbchain.org";
  }
};

const Header = () => {
  const location = useLocation();
  const selectedNetworkIds: any = useNetworkState();
  const web3 = new Web3(fillRPC(selectedNetworkIds));
  const { address }: any = useAccount();
  const { disconnect } = useDisconnect();
  const { openConnectModal } = useConnectModal();
  const [balanceToken, setBalanceToken]: any = useState(0);
  const [open, setOpen] = useState(false);
  const [isShowMenu, setIsShowMenu] = useState(false);
  const [chainNotConnect, setChainNotConnect] = useState(56);
  const [modalOpen, setModalOpen] = useState(false);

  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  const handleDisConnect = () => {
    disconnect();
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(`${address}`);
    message.success({
      type: "success",
      content: "Copied Successfully",
      className: "custom-class",
      duration: 2,
    });
  };

  const getBalanceTokenNative = async () => {
    try {
      const weiBalance = await web3.eth.getBalance(address);
      const bnbBalance = formatFromWei(weiBalance, 18);
      setBalanceToken(bnbBalance);
    } catch (err) {
      console.log("err", err);
    }
  };

  useEffect(() => {
    if (address) {
      getBalanceTokenNative();
    }
  }, [address, selectedNetworkIds]);

  let navigate = useNavigate();

  const handleMobileNavigate = (path: string) => {
    onClose();
    navigate(path);
  };

  const showMenuClick = () => {
    setIsShowMenu(!isShowMenu);
  };

  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const rowUserInfo = () => {
    return (
      <>
        <div className="main-dropdown-wl">
          <div className="top-dropdown">
            <div className="box-balance">
              <div className="icon">
                <img src={fillNetwork(selectedNetworkIds)} alt="" />
              </div>
              <div className="balance">
                <span className="name-bl">
                  {fillNetive(selectedNetworkIds)} Balance
                </span>
                <span className="number-bl">
                  {Number(balanceToken).toFixed(4)}{" "}
                  {fillNetive(selectedNetworkIds)}
                </span>
              </div>
            </div>
            <div className="box-address">
              <div className="address-name">Wallet address:</div>
              <div className="account-name">
                {address?.substring(0, 4)}...
                {address?.substring(address.length - 4)}
                <span className="img-copy" onClick={handleCopy}>
                  <img src="/images/copy.png" alt="" />
                </span>
              </div>
            </div>
          </div>
          <div className="footer-dropdown">
            <button
              type="button"
              className="btn-dis"
              onClick={handleDisConnect}
            >
              Disconnect Wallet
            </button>
          </div>
        </div>
      </>
    );
  };

  return (
    <>
      <style>
        {`
            .header .main-menu ul.list-menu li.active {
                color: #007bff !important;
                font-weight: 600;
                position: relative;
            }
            .main-menu ul.list-menu li.active {
                color: #007bff !important;
                font-weight: 600;
                position: relative;
            }
            .main-menu ul.list-menu li {
                position: relative;
                display: inline-block;
            }
        `}
      </style>
      <NetworkModal
        {...{ chainNotConnect, setChainNotConnect, modalOpen, setModalOpen }}
      />
      <header className={`header ${isScrolled ? "shrink" : ""}`}>
        <div className="container-fluid">
          {isTablet || isMobile ? (
            <>
              <div className="main-header-mobile">
                <div className="left">
                  <div
                    className="box-img"
                    onClick={() => handleMobileNavigate("/")}
                  >
                    <img src="/images/logo.png" alt="" />
                  </div>
                </div>
                <div className="right">
                  <button
                    className="right-chain mx-2 xs:mr-4 min-w-10 min-h-10 !h-10 md:h-12 md:min-h-12 md:min-w-12"
                    onClick={() => setModalOpen(true)}
                  >
                    {address ? (
                      <img src={fillNetwork(selectedNetworkIds)} alt="" />
                    ) : (
                      <img src={fillNetwork(chainNotConnect)} alt="" />
                    )}
                  </button>
                  {address ? (
                    <>
                      <Dropdown overlay={rowUserInfo} placement="bottom">
                        <button className="main-button !w-32 xs:!w-40">
                          <span>
                            {address?.substring(0, 4)}...
                            {address?.substring(address.length - 4)}
                          </span>
                        </button>
                      </Dropdown>
                    </>
                  ) : (
                    <>
                      <button
                        className="main-button min-w-36"
                        onClick={openConnectModal}
                      >
                        <span>Connect</span>
                      </button>
                    </>
                  )}
                  <div className="button-hamberger">
                    <div className="icon-ham">
                      {open ? (
                        <>
                          <img src="/images/menu-active.png" alt="" />
                        </>
                      ) : (
                        <>
                          <img
                            src="/images/menu.png"
                            alt=""
                            onClick={showDrawer}
                          />
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="main-header">
                <div className="left">
                  <div
                    className="box-img"
                    onClick={() => handleMobileNavigate("/")}
                  >
                    <img src="/images/logo.png" alt="" />
                  </div>
                </div>
                <div className="center">
                  <div className="main-menu">
                    <ul className="list-menu">
                      <Link to="/">
                        <li
                          className={location.pathname === "/" ? "active" : ""}
                        >
                          Home
                        </li>
                      </Link>
                      <Link to="/launchpads">
                        <li
                          className={
                            location.pathname === "/launchpads" ? "active" : ""
                          }
                        >
                          Launchpad
                        </li>
                      </Link>
                      <Link to="/airdrop">
                        <li
                          className={
                            location.pathname === "/airdrop" ? "active" : ""
                          }
                        >
                          Airdrop
                        </li>
                      </Link>
                      {
                        <Link to="/nft">
                          <li
                            className={
                              location.pathname === "/nft" ? "active" : ""
                            }
                          >
                            NFT
                          </li>
                        </Link>
                      }
                      <li
                        onClick={() =>
                          window.open("https://gamehub.tinyblock.io/")
                        }
                      >
                        Gamehub
                      </li>
                      <li className="community-menu">
                        Community <img src="/images/arr-menu.png" alt="" />
                        <ul className="sub-menu">
                          <li
                            onClick={() =>
                              window.open("https://x.com/TinyBlock_io")
                            }
                          >
                            <img
                              className="img-menu"
                              src="/images/icon-social-x.png"
                              alt=""
                            />
                            X.com
                          </li>
                          <li
                            onClick={() =>
                              window.open("https://discord.gg/M2TaS3ZQhY")
                            }
                          >
                            <img
                              className="img-menu"
                              src="/images/icon-social-dis.png"
                              alt=""
                            />
                            Discord
                          </li>
                          <li
                            onClick={() =>
                              window.open("http://t.me/tinyblock_io")
                            }
                          >
                            <img
                              className="img-menu"
                              src="/images/icon-social-tele.png"
                              alt=""
                            />
                            Telegram
                          </li>
                          <li
                            onClick={() =>
                              window.open(
                                "https://www.youtube.com/@TinyBlock_io"
                              )
                            }
                          >
                            <img
                              className="img-menu"
                              src="/images/icon-social-y.png"
                              alt=""
                            />
                            Youtube
                          </li>
                          <li
                            onClick={() =>
                              window.open("https://substack.com/@tinyblock")
                            }
                          >
                            <img
                              className="img-menu"
                              src="/images/icon-social-sub.png"
                              alt=""
                            />
                            Substack
                          </li>
                          <li
                            onClick={() =>
                              window.open("https://docs.tinyblock.io/")
                            }
                          >
                            <img
                              className="img-menu"
                              src="/images/icon-social-doc.png"
                              alt=""
                            />
                            Docs
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="right">
                  <button
                    className="right-chain"
                    onClick={() => setModalOpen(true)}
                  >
                    {address ? (
                      <img src={fillNetwork(selectedNetworkIds)} alt="" />
                    ) : (
                      <img src={fillNetwork(chainNotConnect)} alt="" />
                    )}
                  </button>
                  {address ? (
                    <>
                      <Dropdown overlay={rowUserInfo} placement="bottom">
                        <button className="main-button w-150">
                          {address?.substring(0, 4)}...
                          {address?.substring(address.length - 4)}
                        </button>
                      </Dropdown>
                    </>
                  ) : (
                    <>
                      <button
                        className="main-button w-200"
                        onClick={openConnectModal}
                      >
                        Connect Wallet
                      </button>
                    </>
                  )}
                </div>
              </div>
            </>
          )}
        </div>
      </header>
      <Drawer
        title="Basic Drawer"
        className="drawer-mobile"
        placement="right"
        onClose={onClose}
        open={open}
      >
        <div className="button-hamberger">
          <div className="icon-ham">
            <img src="/images/menu-active.png" alt="" onClick={onClose} />
          </div>
        </div>
        <div className="top-drawer">
          <div className="box-img" onClick={() => handleMobileNavigate("/")}>
            <img src="/images/logo.png" alt="" />
          </div>
        </div>
        <div className="main-menu">
          <ul className="list-menu">
            <li
              onClick={() => handleMobileNavigate("/")}
              className={location.pathname === "/" ? "active" : ""}
            >
              Home
            </li>
            <li
              onClick={() => handleMobileNavigate("/launchpads")}
              className={location.pathname === "/launchpads" ? "active" : ""}
            >
              Launchpad
            </li>
            <li
              onClick={() => handleMobileNavigate("/airdrop")}
              className={location.pathname === "/airdrop" ? "" : "unactive"}
            >
              Airdrop
            </li>
            {
              <li
                onClick={() => handleMobileNavigate("/nft")}
                className={location.pathname === "/nft" ? "" : "unactive"}
              >
                NFT
              </li>
            }
            <li onClick={() => window.open("https://gamehub.tinyblock.io/")}>
              Gamehub
            </li>
            <li
              onClick={showMenuClick}
              className={location.pathname === "/community" ? "active" : ""}
            >
              Community <img src="/images/arr-menu.png" alt="" />
            </li>
            {isShowMenu && (
              <ul className="sub-menu-mobile">
                <li onClick={() => window.open("https://x.com/TinyBlock_io")}>
                  <img
                    className="img-menu"
                    src="/images/icon-social-x.png"
                    alt=""
                  />
                  X.com
                </li>
                <li
                  onClick={() => window.open("https://discord.gg/M2TaS3ZQhY")}
                >
                  <img
                    className="img-menu"
                    src="/images/icon-social-dis.png"
                    alt=""
                  />
                  Discord
                </li>
                <li onClick={() => window.open("http://t.me/tinyblock_io")}>
                  <img
                    className="img-menu"
                    src="/images/icon-social-tele.png"
                    alt=""
                  />
                  Telegram
                </li>
                <li
                  onClick={() =>
                    window.open("https://www.youtube.com/@TinyBlock_io")
                  }
                >
                  <img
                    className="img-menu"
                    src="/images/icon-social-y.png"
                    alt=""
                  />
                  Youtube
                </li>
                <li
                  onClick={() => window.open("https://substack.com/@tinyblock")}
                >
                  <img
                    className="img-menu"
                    src="/images/icon-social-sub.png"
                    alt=""
                  />
                  Substack
                </li>
                <li onClick={() => window.open("https://docs.tinyblock.io/")}>
                  <img
                    className="img-menu"
                    src="/images/icon-social-doc.png"
                    alt=""
                  />
                  Docs
                </li>
              </ul>
            )}
          </ul>
        </div>
      </Drawer>
    </>
  );
};

export default Header;
